import React, { Component, createRef } from "react";
import { selectResource as sr, clearResource as cr } from "../map/ducks";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

class PItem extends Component {
  pathRef = createRef();

  componentDidUpdate() {
    const { selected, parentRef } = this.props;
    if (selected) {
      parentRef.current.appendChild(this.pathRef.current);
    }
  }

  render() {
    const {
      id,
      line,
      selected,
      noSelectedColor,
      selectResource,
      clearResource
    } = this.props;
    return (
      <path
        onMouseOver={() => selectResource(id)}
        onMouseOut={() => clearResource()}
        ref={this.pathRef}
        key={`line-${id}`}
        d={line}
        strokeWidth="2.5"
        stroke={selected ? "steelblue" : noSelectedColor}
        mixblendmode={selected ? null : "multiply"}
      />
    );
  }
}

const mapDispatchToProps = dispatch =>
  bindActionCreators({ selectResource: sr, clearResource: cr }, dispatch);

export default connect(
  undefined,
  mapDispatchToProps
)(PItem);



// WEBPACK FOOTER //
// ./src/components/barChart/PItem.js